import baggageAdd from './baggageAddSchema';
import baggageClick from './baggageClickSchema';
import baggageImpression from './baggageImpressionSchema';
import baggageRemove from './baggageRemoveSchema';
import checkout from './checkoutSchema';
import continueChubb from './continueSchema';
import lookup from './lookupSchema';
import promotion from './promotionSchema';
import purchase from './purchaseSchema';
import newPurchase from './newPurchaseSchema';
import tierBenefit from './tierBenefitSchema';
import tierBenefitRedemption from './tierBenefitSchemaRedemption';
import error from './errorSchema';
import frequentFlyer from './frequentFlyerSchema';
import formError from './formErrorSchema';
import welcomeModal from './welcomeModalSchema';
import sendEmailDispatch from './sendEmailDispatch';
import promotionImpression from './promotionImpressionSchema';
import promotionPopUpSchema from './promotionPopUpSchema';
import registerCP from './registerCPSchema';
import errorFromCMS from './errorFromCMS';
import registerFailCP from './registerFailCPSchema';
import webErrorSchema from './webErrorSchema';
import webErrorTrackingSchema from './webErrorTrackingSchema';
import receiptSchema from './receiptSchema';
import viewPromotionSchema from './viewPromotionSchema';
import selectPromotionSchema from './selectPromotionSchema';
import stepFlightSchema from './stepFlightSchema';
import stepInitSchema from './stepInitSchema';

export default {
  baggageAdd,
  baggageClick,
  baggageImpression,
  baggageRemove,
  checkout,
  continueChubb,
  error,
  errorFromCMS,
  formError,
  frequentFlyer,
  lookup,
  newPurchase,
  sendEmailDispatch,
  promotion,
  promotionImpression,
  promotionPopUpSchema,
  purchase,
  receiptSchema,
  registerCP,
  registerFailCP,
  selectPromotionSchema,
  stepFlightSchema,
  stepInitSchema,
  tierBenefit,
  tierBenefitRedemption,
  webErrorTrackingSchema,
  viewPromotionSchema,
  welcomeModal,
  webErrorSchema,
};
